module.exports = __webpack_public_path__ + "media/hand.838bf069.mp4";